module.exports = __webpack_public_path__ + "img/health-record.3d736468.png";